import { isWatchWorkoutSource, watchDeviceLabel, watchHealthSourceLabel } from "./watchPlatform"

function id(value) {
  return String(value?._id || value || "").trim()
}

function titleKey(value) {
  return String(value || "").trim().toLocaleLowerCase("de-CH")
}

// A course name can occur more than once per day. Prefer the actual booking;
// only old records without that identifier may use an unambiguous title match.
export function calendarActivities(day, { showWatchDetails = false, normalizeHealth = () => null } = {}) {
  const workouts = (Array.isArray(day?.workouts) ? day.workouts : []).map((workout, index) => {
    const isWatch = Boolean(isWatchWorkoutSource(workout?.source) && workout?.watchData)
    const activity = workout?.watchData?.activity || {}
    const isGroupFitness = isWatch && activity.type === "group_fitness"
    const visibleWatch = showWatchDetails && isWatch
    const deviceLabel = visibleWatch ? watchDeviceLabel(workout?.source, workout?.watchData?.platform) : ""
    return {
      id: `workout-${workout?._id || workout?.clientSessionId || index}`,
      title: workout.title || activity.title || (isGroupFitness ? "Groupfitness" : "Training"),
      type: isGroupFitness ? "Groupfitness" : activity.type === "phone_companion" && visibleWatch
        ? "Handy-Training · Watch-Puls" : visibleWatch ? `${deviceLabel} Training` : "Training",
      icon: isGroupFitness ? "mdi-account-group" : visibleWatch ? "mdi-heart-pulse" : "mdi-dumbbell",
      isGroupFitness,
      isWatch: visibleWatch,
      courseExecutionId: isGroupFitness ? id(activity.courseExecutionId) : "",
      startAt: isGroupFitness ? activity.startAt || null : null,
      status: isGroupFitness ? "recorded" : null,
      watchDeviceLabel: deviceLabel,
      watchHealthSource: visibleWatch ? watchHealthSourceLabel(workout?.source, workout?.watchData?.platform) : "",
      watchHealth: visibleWatch ? normalizeHealth(workout) : null,
      workout,
    }
  })
  const seenCourses = new Set()
  const courses = (Array.isArray(day?.courseArray) ? day.courseArray : []).filter((course) => {
    const key = id(course.courseExecutionId)
    if (!key) return true
    if (seenCourses.has(key)) return false
    seenCourses.add(key)
    return true
  })
  const used = new Set()
  const merged = courses.map((course, index) => {
    const title = String(course.course?.name || "Groupfitness").trim()
    const executionId = id(course.courseExecutionId)
    const candidates = workouts.filter((workout) => workout.isGroupFitness && !used.has(workout.id))
    let match = executionId ? candidates.find((workout) => workout.courseExecutionId === executionId) : null
    if (!match) {
      const sameTitle = candidates.filter((workout) => titleKey(workout.title) === titleKey(title))
      const uniqueCourse = courses.filter((entry) => titleKey(entry.course?.name || "Groupfitness") === titleKey(title)).length === 1
      if (uniqueCourse && sameTitle.length === 1 && (!executionId || !sameTitle[0].courseExecutionId)) match = sameTitle[0]
    }
    if (match) used.add(match.id)
    return {
      id: `course-${executionId || `${course.course?._id || title}-${course.time || ""}-${index}`}`,
      type: "Groupfitness",
      icon: "mdi-account-group",
      isGroupFitness: true,
      isWatch: false,
      watchHealth: null,
      ...match,
      title,
      courseExecutionId: executionId || match?.courseExecutionId || "",
      startAt: course.startAt || match?.startAt || null,
      time: course.time || "",
      status: match ? "recorded" : course.status || "visited",
    }
  })
  return [...merged, ...workouts.filter((workout) => !used.has(workout.id))]
}
